var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.224 2.74c1.56 2 3.35 3.75 5 5.67a46.365 46.365 0 004.82 5.09c3.68 3.27 7.3 6.63 10.92 10 1.18 1.09 3-.67 1.77-1.77-3.63-3.34-7.24-6.69-10.93-10a47.394 47.394 0 01-4.82-5.09c-1.61-1.92-3.41-3.69-5-5.67-1-1.27-2.75.51-1.77 1.77h.01z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.004 23.47c3.91-3.53 7.68-7.2 11.51-10.81 3.31-3.13 6.33-6.53 9.36-9.92 1.07-1.2-.69-3-1.77-1.77-3 3.39-6 6.8-9.36 9.92-3.82 3.62-7.6 7.29-11.51 10.81-1.2 1.08.58 2.85 1.77 1.77z"
  })));
}
export default SvgClose;